import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LogoTeamsSimplified = function LogoTeamsSimplified(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 115,
    height: 32,
    viewBox: "0 0 115 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "logo.teams.simplified",
    clipPath: "url(#clip0_5806_561)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "mask0_5806_561",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "clip0_483_5042"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), /*#__PURE__*/React__default.createElement("g", {
    mask: "url(#mask0_5806_561)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "mask1_5806_561",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "clip1_483_5042"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_2",
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), /*#__PURE__*/React__default.createElement("g", {
    mask: "url(#mask1_5806_561)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_3",
    d: "M21.4906 7.15989C24.9115 7.15989 27.985 8.66049 30.0696 11.0588C30.7778 11.8627 32.1008 11.3133 31.9939 10.2415C31.927 9.54477 31.7934 8.83467 31.593 8.12456C30.5373 4.34628 27.5173 1.39868 23.7356 0.407211C16.1321 -1.60251 9.29028 4.10511 9.29028 11.4071C9.29028 11.8761 9.31701 12.345 9.37046 12.8005C9.50409 13.859 10.9206 14.1269 11.4283 13.1891C13.3526 9.59836 17.1343 7.15989 21.4906 7.15989Z",
    fill: "#FFA310"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_4",
    d: "M7.16402 10.5093C7.16402 7.08844 8.66368 4.01498 11.0605 1.93036C11.8638 1.22213 11.3149 -0.100797 10.2437 0.00610588C9.53402 0.0729204 8.82436 0.206549 8.11469 0.39363C4.33877 1.46266 1.39301 4.46932 0.402164 8.25102C-1.59292 15.8679 4.11114 22.7097 11.4086 22.7097C11.8772 22.7097 12.3459 22.683 12.8011 22.6295C13.8589 22.4959 14.1267 21.0794 13.1894 20.5716C9.60096 18.6474 7.16402 14.8657 7.16402 10.5093Z",
    fill: "#149EF2"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_5",
    d: "M10.5032 24.8491C7.08428 24.8491 4.01262 23.3495 1.92923 20.9527C1.22141 20.1493 -0.100738 20.6983 0.00610232 21.7695C0.0728775 22.4658 0.206428 23.1754 0.406754 23.8851C1.4618 27.661 4.48004 30.6068 8.25952 31.5976C15.8719 33.5927 22.7097 27.8886 22.7097 20.5912C22.7097 20.1225 22.683 19.6539 22.6295 19.1986C22.496 18.1408 21.0804 17.873 20.5729 18.8103C18.6364 22.4122 14.8569 24.8491 10.5032 24.8491Z",
    fill: "#F20057"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_6",
    d: "M24.8494 21.497C24.8494 24.9159 23.3497 27.9876 20.9529 30.071C20.1496 30.7788 20.6985 32.1009 21.7697 31.9941C22.466 31.9273 23.1757 31.7938 23.8853 31.5935C27.6612 30.5384 30.607 27.5202 31.5979 23.7407C33.5929 16.1283 27.8889 9.29053 20.5914 9.29053C20.1228 9.29053 19.6541 9.31724 19.1989 9.37066C18.1411 9.50421 17.8733 10.9198 18.8106 11.4273C22.4124 13.3638 24.8494 17.1433 24.8494 21.497Z",
    fill: "#8252DD"
  }))))))), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_7",
    d: "M109.49 25.9335C106.539 25.9335 104.632 24.8627 103.797 22.7213C103.64 22.3035 103.745 22.0424 104.189 21.8857L105.103 21.5723C105.494 21.4417 105.703 21.4939 105.912 21.964C106.434 23.3481 107.61 23.8704 109.438 23.8704C111.657 23.8704 112.728 23.1653 112.728 21.8596C112.728 20.2927 111.422 20.0054 109.229 19.7965C106.617 19.5353 103.953 19.0914 103.953 15.7226C103.953 13.2939 105.703 11.6748 109.203 11.6748C112.206 11.6748 113.851 12.7977 114.661 14.4952C114.896 14.9653 114.765 15.2264 114.321 15.4092L113.433 15.7748C112.989 15.9576 112.859 15.9054 112.571 15.4876C112.101 14.4691 111.266 13.764 109.255 13.764C107.218 13.764 106.252 14.4169 106.252 15.6704C106.252 17.3417 107.636 17.5506 109.803 17.7595C112.78 18.0207 115 18.6736 115 21.7551C115 24.236 113.146 25.9335 109.49 25.9335Z",
    fill: "#000A23"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_8",
    d: "M82.8879 25.5417C82.4178 25.5417 82.2611 25.385 82.2611 24.915V14.0251C82.2611 13.2156 82.47 12.8761 83.2535 12.5366C84.2197 12.1188 85.5777 11.6748 87.7452 11.6748C89.2337 11.6748 90.3306 12.0143 91.114 12.6672C91.8191 12.3799 93.386 11.6748 95.8147 11.6748C99.2879 11.6748 100.803 13.5028 100.803 16.7411V24.915C100.803 25.385 100.646 25.5417 100.176 25.5417H99.1051C98.6351 25.5417 98.4784 25.385 98.4784 24.915V16.8194C98.4784 14.8086 97.5121 13.7901 95.5013 13.7901C94.0127 13.7901 92.9159 14.2863 92.3675 14.4952C92.6548 15.122 92.7592 15.8793 92.7592 16.7411V24.915C92.7592 25.385 92.6287 25.5417 92.1586 25.5417H91.0618C90.5917 25.5417 90.435 25.385 90.435 24.915V16.8194C90.435 14.8086 89.4427 13.7901 87.4057 13.7901C86.3611 13.7901 85.6299 13.9729 84.9248 14.234C84.6114 14.3646 84.5853 14.5474 84.5853 14.7825V24.915C84.5853 25.385 84.4286 25.5417 83.9586 25.5417H82.8879Z",
    fill: "#000A23"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_9",
    d: "M73.3009 25.9335C68.7308 25.9335 67.5818 24.4449 67.5818 21.7812C67.5818 18.7258 69.2792 17.7073 73.4054 17.7073C74.7111 17.7073 75.9385 17.864 76.4086 17.8901V16.8716C76.4086 15.0175 75.7557 13.7379 73.3009 13.7379C71.7079 13.7379 70.6633 14.2863 70.0366 15.357C69.7754 15.7487 69.6449 15.827 69.2009 15.6442L68.3652 15.3048C67.9213 15.122 67.7907 14.8869 68.0257 14.4169C68.9398 12.6933 70.6633 11.6748 73.3531 11.6748C77.5576 11.6748 78.7328 13.999 78.7328 16.95V23.7659C78.7328 24.6799 78.5239 24.9411 77.7927 25.2545C76.8264 25.6723 75.3379 25.9335 73.3009 25.9335ZM73.092 24.001C74.5022 24.001 75.3901 23.8704 75.9907 23.6615C76.3302 23.557 76.4086 23.4526 76.4086 23.0869V19.7443C75.8863 19.692 74.45 19.5615 73.1442 19.5615C70.6894 19.5615 69.9321 20.2927 69.9321 21.7551C69.9321 23.1392 70.4805 24.001 73.092 24.001Z",
    fill: "#000A23"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_10",
    d: "M59.1799 25.9335C55.106 25.9335 53.3563 23.6876 53.3563 20.5016V17.2634C53.3563 13.7379 55.4194 11.6748 59.2583 11.6748C63.2799 11.6748 65.1602 13.999 65.1602 17.0806V18.5952C65.1602 19.1436 64.9252 19.5092 64.2201 19.5092H55.6805V20.7627C55.6805 22.7475 56.9079 23.9226 59.1799 23.9226C61.0602 23.9226 62.1831 23.1914 62.836 22.0946C63.1494 21.6768 63.3844 21.5984 63.8545 21.8596L64.5595 22.2252C65.0035 22.4602 65.0818 22.7997 64.7946 23.2436C63.8545 24.8366 62.1831 25.9335 59.1799 25.9335ZM55.6805 17.7073H62.836V16.95C62.836 14.8869 61.6347 13.6595 59.2583 13.6595C56.9079 13.6595 55.6805 14.8869 55.6805 16.95V17.7073Z",
    fill: "#000A23"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_11",
    d: "M46.3981 25.5415C45.8758 25.5415 45.7191 25.3587 45.7191 24.8625V9.35033H40.679C40.1828 9.35033 40 9.16752 40 8.64523V7.67898C40 7.1828 40.1828 7 40.679 7H53.2402C53.7625 7 53.9192 7.1828 53.9192 7.67898V8.64523C53.9192 9.16752 53.7625 9.35033 53.2402 9.35033H48.2261V24.8625C48.2261 25.3587 48.0433 25.5415 47.5472 25.5415H46.3981Z",
    fill: "#000A23"
  })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_5806_561"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: 115,
    height: 32,
    fill: "white"
  }))));
};

export { LogoTeamsSimplified };
